module.exports = __webpack_public_path__ + "static/media/logo-binance@2x.44b19fd3.png";